import { z } from "zod"

/**
 * @description
 *	The schema of {@link URI} type.
 */
export const URISchema = z.url()

/**
 * @description
 *	An URI (Uniform Resource Identifier).
 *
 * @see https://en.wikipedia.org/wiki/Uniform_Resource_Identifier
 */
export type URI = z.infer<typeof URISchema>
